var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#6d6e72",
    strokeOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4865 14.3797C26.6253 13.9851 26.4865 13.6981 25.8719 13.6981H23.8298C23.3144 13.6981 23.0764 13.9492 22.9377 14.2183C22.9377 14.2183 21.8869 16.5141 20.4198 18.0027C19.9439 18.4332 19.7259 18.5767 19.4682 18.5767C19.3293 18.5767 19.1509 18.4332 19.1509 18.0386V14.3617C19.1509 13.8954 18.9923 13.6802 18.5561 13.6802H15.3444C15.0271 13.6802 14.8289 13.8954 14.8289 14.1106C14.8289 14.5591 15.5624 14.6667 15.6417 15.9222V18.6484C15.6417 19.2403 15.5228 19.3479 15.2651 19.3479C14.5711 19.3479 12.886 17.0342 11.8748 14.3976C11.6765 13.8775 11.4783 13.6802 10.9629 13.6802H8.90093C8.30617 13.6802 8.20703 13.9313 8.20703 14.2003C8.20703 14.6846 8.90093 17.1239 11.4386 20.3524C13.1239 22.5585 15.5228 23.7422 17.6838 23.7422C18.9923 23.7422 19.1509 23.4732 19.1509 23.0248V21.3568C19.1509 20.8187 19.2699 20.729 19.6862 20.729C19.9836 20.729 20.5189 20.8725 21.7283 21.9307C23.1161 23.1862 23.354 23.7602 24.1272 23.7602H26.1693C26.764 23.7602 27.0416 23.4911 26.883 22.971C26.7046 22.4509 26.0305 21.6976 25.1582 20.8007C24.6823 20.2986 23.9686 19.7426 23.7505 19.4735C23.4531 19.1148 23.5324 18.9713 23.7505 18.6484C23.7307 18.6484 26.2287 15.4559 26.4865 14.3797Z",
    fill: "#6d6e72",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.7145f860adee68c71ce972cef4d4983f.svg";
export { ForwardRef as ReactComponent };